// Product Page 
document.addEventListener("DOMContentLoaded", function() {
    // Get the height of the headerDiv
    var headerHeight = document.getElementById("pageheader").offsetHeight;
    // Get the position of the mainDiv relative to the document
    var mainDiv = document.querySelector(".section-main-product .product-info.container");
    if(mainDiv) {
      var mainDivTop = mainDiv.getBoundingClientRect().top + window.pageYOffset;
      // Scroll to the mainDiv, offset by the header height
      window.scrollTo({ top: mainDivTop - headerHeight, behavior: 'smooth' });
    }
});

// Product Page end

// Collection page add to cart

customElements.define('card-variant-selector',
  class CardVariantSelector extends HTMLElement {
    constructor() {
      super();
      this.options = this.querySelectorAll('.option-selector .opt-label');
      this.options.forEach(function (opt) {

        opt.addEventListener('click', function ()  { 
          const selector = this.closest('.option-selector');
          const firstSelector = selector.parentElement.querySelector('.option-selector');
          const isATC = selector && selector.hasAttribute('data-card-atc');
          if (isATC) {
            this.control.checked ? this.control.dispatchEvent(new Event('change', { bubbles: true })) : null;
          }

          if (!this.closest('card-variant-selector').hasAttribute('only-one-option')) {
            selector.removeAttribute('active');
  
            if (selector.nextElementSibling && selector.nextElementSibling.classList.contains('option-selector')) {
              selector.nextElementSibling.setAttribute('active', '');
              selector.nextElementSibling.classList.add('animate');
              // Listen for the animation to end
              selector.nextElementSibling.addEventListener('animationend', () => selector.nextElementSibling.classList.remove('animate'));
              selector.nextElementSibling.addEventListener("animationcancel", () => selector.nextElementSibling.classList.remove('animate'));
            } else {
              firstSelector.setAttribute('active', '');
              firstSelector.classList.add('animate');
              // Listen for the animation to end
              firstSelector.addEventListener('animationend', () => firstSelector.classList.remove('animate'));
              firstSelector.addEventListener("animationcancel", () => firstSelector.classList.remove('animate'));
            } 
          }

        })
      });
    }
  });

function handleMobileCartATCClick(evt) {
    if (evt.target.classList.contains('mobile-card-atc-content') || evt.target.name == 'add' ||
        evt.target.classList.contains('atc-close') || evt.target.classList.contains('atc-close-path')) {
          let timeout = 0;
          if(evt.target.name == 'add') timeout = 1000;
          setTimeout(() => evt.target.closest('.mobile-card-atc').removeAttribute('open'), timeout);
    }
}

document.querySelectorAll('.card-atc-wrapper:not(.on_cart_drawer_true)').forEach(element => {
  document.body.append(element);
});

customElements.define('cart-upsell-opener', class CartUpsellOpener extends HTMLElement {
  constructor() {
    super();
    this.popup = document.querySelector(`${this.dataset.popup}`); 
    if(!this.popup) return;
    this.addEventListener('click', function ()  {
      if (this.popup.nodeName.toLowerCase() === 'details') {
        this.popup.open = true;
      } else {
        this.popup.click();
      }
    })
  }
})

// Collection page add to cart end
customElements.define('infinite-scroll-collection', class InfiniteScrollCollection extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', function() {
      let loading = false;
    
      window.addEventListener('scroll', function() {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1000 && !loading) {
          loading = true;
          fetchNextPage();
        }
      });
    
      function fetchNextPage() {
        const nextPageLink = document.querySelector('infinite-scroll-collection a');
    
        if (nextPageLink) {
          const url = nextPageLink.href;
          document.getElementById('collectionGridLoading').style.display = 'flex';
    
          fetch(url)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newProducts = doc.querySelector('.collection-listing[data-ajax-container]').innerHTML;

              document.querySelector('.collection-listing[data-ajax-container]').insertAdjacentHTML('beforeend', newProducts);
              document.getElementById('collectionGridLoading').style.display = 'none';
    
              // Update the next page link
              const newNextPageLink = doc.querySelector('#collection-next-page');
              if (newNextPageLink) {  nextPageLink.href = newNextPageLink.href; } 
              else { nextPageLink.parentNode.removeChild(nextPageLink); }
    
              loading = false;
            })
            .catch(error => {
              console.error('Error fetching next page:', error);
              loading = false;
            });
        } 
        else {
          document.getElementById('collectionGridLoading').style.display = 'none';
          loading = false;
        }
      }
    });
  }
})

// Collection Page

// $(".append_block").contents().appendTo(".append_here");
//     $(".append_block").remove(); 

// Collection Page end

// Cart Drawer
customElements.define('abz-cart-upsells', class AbzCartUpsells extends HTMLElement {
  constructor() {
    super();
    setTimeout(function() {
      $('.abz-cart-upsells .grid').slick({
        speed: 300,
        arrows: true,
        infinite:false,
        slidesToShow: 1.3,
        slidesToScroll: 1,
        prevArrow: $('.abz-cart-upsells-nav .slick-prev'),
        nextArrow: $('.abz-cart-upsells-nav .slick-next'),
      });
    }, 0); // Adjust delay as needed
  }
})
// Cart Drawer End
// Product Page

$(window).scroll(function(){
  if ($(window).scrollTop() >= 600) {
    $('.card-bottom-fix').addClass('fixed');
   }
   else {
    $('.card-bottom-fix').removeClass('fixed');
   }
});

// Product Page End



// Collection Tabs
$(".tab_header li").click(function () {
  $this = $(this);
  $target = $(this).attr("id");
  $section = $(this).attr("section");
  $($section + " .tab_header li.current").removeClass("current");
  $($this).addClass("current");
  $($section + " .tab-content").removeClass("show is-draggable");
  $($section + " .tab_data #" + $target).addClass("show is-draggable");
  $($section + " .tab_data #" + $target + " .slick-initialized").slick("refresh");
  window.dispatchEvent(new Event("resize"));
});

// Collection Tabs End



// Counter on page

var counted = 0;
$(window).scroll(function() {
if ($('#counter') && $('#counter').offset()) {
  var oTop = $('#counter').offset().top - window.innerHeight;
  if (counted == 0 && $(window).scrollTop() > oTop) {
    $('.count').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },
  
        {
  
          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(Math.ceil(this.countNum).toLocaleString());
            //alert('finished');
          }
  
        });
    });
    counted = 1;
  }
}

});

// Counter on page End

// Home Page Tab Slider


$('.collection_tabs_data').slick({
  speed: 300,
  arrows: true,
  infinite:false,
  slidesToShow: 4.5,
  slidesToScroll: 1,
  prevArrow: '<svg class="slick-prev slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.43098e-07 12C-1.37969e-07 11.5698 0.168066 11.1398 0.503491 10.8118L11.0639 0.49234C11.7357 -0.164113 12.8249 -0.164113 13.4964 0.49234C14.1679 1.14853 14.1679 2.21264 13.4964 2.86915L4.15191 12L13.496 21.1308C14.1675 21.7873 14.1675 22.8513 13.496 23.5074C12.8245 24.1642 11.7354 24.1642 11.0636 23.5074L0.503164 13.1881C0.167684 12.86 -1.48225e-07 12.4299 -1.43098e-07 12Z" fill="#161616"/></svg>',
  nextArrow: '<svg class="slick-next slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 12C14 11.5698 13.8319 11.1398 13.4965 10.8118L2.93607 0.49234C2.2643 -0.164113 1.17513 -0.164113 0.503627 0.49234C-0.167876 1.14853 -0.167876 2.21264 0.503627 2.86915L9.84809 12L0.503954 21.1308C-0.167549 21.7873 -0.167549 22.8513 0.503954 23.5074C1.17546 24.1642 2.26462 24.1642 2.9364 23.5074L13.4968 13.1881C13.8323 12.86 14 12.4299 14 12Z" fill="#161616"/></svg>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    }
  ]
});

// Home Page Tab Slider End


// Blog

$('.abz-blog-slider').slick({
  speed: 300,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<svg class="slick-prev slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.43098e-07 12C-1.37969e-07 11.5698 0.168066 11.1398 0.503491 10.8118L11.0639 0.49234C11.7357 -0.164113 12.8249 -0.164113 13.4964 0.49234C14.1679 1.14853 14.1679 2.21264 13.4964 2.86915L4.15191 12L13.496 21.1308C14.1675 21.7873 14.1675 22.8513 13.496 23.5074C12.8245 24.1642 11.7354 24.1642 11.0636 23.5074L0.503164 13.1881C0.167684 12.86 -1.48225e-07 12.4299 -1.43098e-07 12Z" fill="#161616"/></svg>',
  nextArrow: '<svg class="slick-next slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 12C14 11.5698 13.8319 11.1398 13.4965 10.8118L2.93607 0.49234C2.2643 -0.164113 1.17513 -0.164113 0.503627 0.49234C-0.167876 1.14853 -0.167876 2.21264 0.503627 2.86915L9.84809 12L0.503954 21.1308C-0.167549 21.7873 -0.167549 22.8513 0.503954 23.5074C1.17546 24.1642 2.26462 24.1642 2.9364 23.5074L13.4968 13.1881C13.8323 12.86 14 12.4299 14 12Z" fill="#161616"/></svg>',
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


// Blog End



// Footer

window.addEventListener('DOMContentLoaded', () => {
if (window.matchMedia('(min-width: 750px)').matches) {
return
}

const handleCollapse = (heading) => {
if (heading.classList.contains('block-collapsed')) {
heading.classList.remove('block-collapsed')
heading.setAttribute('aria-expanded', 'true')
} else {
heading.classList.add('block-collapsed')
heading.setAttribute('aria-expanded', 'false')
}
}

document.querySelectorAll('.section-footer__title').forEach((heading, index) => {
heading.classList.add('block-collapsed')
heading.setAttribute('role', 'button')
heading.setAttribute('aria-expanded', 'false')
heading.setAttribute('tabindex', '0')

heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`)
heading.setAttribute('aria-controls', `footer-block-index-${index}`)

heading.addEventListener('click', () => { handleCollapse(heading) })
heading.addEventListener('keypress', () => { handleCollapse(heading) })
})

})

// Footer End


// PDP Swatche Slider
if ($('.product-swatches li').length > 6) {

$('.product-swatches').slick({
  speed: 300,
  arrows: false,
  infinite: false,
  slidesToShow: 6,
    slidesToScroll: 6,
  variableWidth: true,
  prevArrow: '<svg class="slick-prev slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.43098e-07 12C-1.37969e-07 11.5698 0.168066 11.1398 0.503491 10.8118L11.0639 0.49234C11.7357 -0.164113 12.8249 -0.164113 13.4964 0.49234C14.1679 1.14853 14.1679 2.21264 13.4964 2.86915L4.15191 12L13.496 21.1308C14.1675 21.7873 14.1675 22.8513 13.496 23.5074C12.8245 24.1642 11.7354 24.1642 11.0636 23.5074L0.503164 13.1881C0.167684 12.86 -1.48225e-07 12.4299 -1.43098e-07 12Z" fill="#161616"/></svg>',
  nextArrow: '<svg class="slick-next slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 12C14 11.5698 13.8319 11.1398 13.4965 10.8118L2.93607 0.49234C2.2643 -0.164113 1.17513 -0.164113 0.503627 0.49234C-0.167876 1.14853 -0.167876 2.21264 0.503627 2.86915L9.84809 12L0.503954 21.1308C-0.167549 21.7873 -0.167549 22.8513 0.503954 23.5074C1.17546 24.1642 2.26462 24.1642 2.9364 23.5074L13.4968 13.1881C13.8323 12.86 14 12.4299 14 12Z" fill="#161616"/></svg>',
    responsive: [
    {
      breakpoint: 700,
      settings: {
        variableWidth: true,
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    }
  ]
});
  
}

// PDP Swatche Slider End


// Plastic removed counter Home Page

$( document ).ready(function() {
  $('.plastic-removed').each(function() {
  var $this = $(this),
      countTo = $this.attr('data-count');
  
    $({ countNum: $this.text()}).animate({
      countNum: countTo
    },
    {
      duration: 3000,
      easing:'linear',
      step: function() {
        $this.text(Math.floor(this.countNum));
      },
      complete: function() {
        //$this.text(this.countNum);
         $this.text(Math.ceil(this.countNum).toLocaleString());
        //alert('finished');
      }
    });
  });
});  


// Plastic removed counter Home Page End

// Collection Page slider


if ($(window).width() <= 1024) {
    var slider = $('#category.is_slider');
     slider.slick({
      slidesToShow: 5.5,
      slidesToScroll: 3,
      arrows: false,
      infinite: false,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 3
      }
    }
  ]
});
   }



// Get the current date
  var currentDate = new Date();

        // Get the month, day, and year
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var month = monthNames[currentDate.getMonth()]; // Use month names array
        var day = currentDate.getDate();
        var year = currentDate.getFullYear();

        // Update the content of the div elements with the current date
        if (document.getElementById("day")) {
            document.getElementById("day").innerHTML = day;
        }
        if (document.getElementById("month")) {
            document.getElementById("month").innerHTML = month;
        }
        if (document.getElementById("year")) {
            document.getElementById("year").innerHTML = year;
        }

// IMPACT COMPOSITION SLIDER

$('.slick-slicder-composition').slick({
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow: '<svg class="slick-prev slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.43098e-07 12C-1.37969e-07 11.5698 0.168066 11.1398 0.503491 10.8118L11.0639 0.49234C11.7357 -0.164113 12.8249 -0.164113 13.4964 0.49234C14.1679 1.14853 14.1679 2.21264 13.4964 2.86915L4.15191 12L13.496 21.1308C14.1675 21.7873 14.1675 22.8513 13.496 23.5074C12.8245 24.1642 11.7354 24.1642 11.0636 23.5074L0.503164 13.1881C0.167684 12.86 -1.48225e-07 12.4299 -1.43098e-07 12Z" fill="#161616"/></svg>',
  nextArrow: '<svg class="slick-next slick-arrow" width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 12C14 11.5698 13.8319 11.1398 13.4965 10.8118L2.93607 0.49234C2.2643 -0.164113 1.17513 -0.164113 0.503627 0.49234C-0.167876 1.14853 -0.167876 2.21264 0.503627 2.86915L9.84809 12L0.503954 21.1308C-0.167549 21.7873 -0.167549 22.8513 0.503954 23.5074C1.17546 24.1642 2.26462 24.1642 2.9364 23.5074L13.4968 13.1881C13.8323 12.86 14 12.4299 14 12Z" fill="#161616"/></svg>',
});

// Customer Hub Account Page
    // Add to merchants customers/account.liquid to inject elements at the top of the Dashboard
    //Add to merchants customers/addresses.liquid to inject elements into the customer account profile page
    // This code is executed when the user is on the '/account' page
    if(location.pathname.includes('/account')){
        // Create an observer to monitor changes in the DOM
        const chElementObserver = new MutationObserver((mutations, obs) => {
            try{
                // Make sure to update the ID #element-to-inject with the ID of the element you want to inject from the account page code.
                var chFindElement = document.querySelector('#myContributionTemplate');
                
                // Check if the element with the specified ID is found
                if (chFindElement) {
                    // Locate the target insert location on the dashboard
                    let chDashInsert = document.querySelector('#chMobMenu');
                    
                    // Create a new div to hold the content to be injected
                    let chInjectDiv = document.createElement('div');
                    chInjectDiv.classList.add("chContent-Body-Page-General");
                    
                    // Copy the inner HTML from the found element to the new div
                    chInjectDiv.innerHTML = chFindElement.innerHTML;
                    
                    // Insert the new div before the target insert location on the dashboard
                    chDashInsert && chDashInsert.append(chInjectDiv);
                    
                    // Disconnect the observer as the operation is complete
                    obs.disconnect();
                    return;
                }
            }catch(e){
                // Log any errors to the console and disconnect the observer
                console.log(e);
                obs.disconnect();
            }
        });
        
        // Start observing the entire document for changes in child elements and their subtrees
        chElementObserver.observe(document, {
            childList: true,
            subtree: true
        });
    }
// End






